import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=44021fba&scoped=true&"
import script from "./Rule.vue?vue&type=script&lang=js&"
export * from "./Rule.vue?vue&type=script&lang=js&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=44021fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44021fba",
  null
  
)

export default component.exports